import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import ConsentPage from './pages/ConsentPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import ChangeEmailPage from './pages/ChangeEmailPage';
import SocialEmailPage from './pages/SocialEmailPage';
import LogoutPage from './pages/LogoutPage';
import UnsubscribePage from './pages/UnsubscribePage';
import DashboardLayout from './layouts/DashboardLayout';
import ProfilePage from './pages/ProfilePage';
import SecurityPage from './pages/SecurityPage';
import AdminUsersPage from './pages/admin/AdminUsersPage';
import AdminClientsPage from './pages/admin/AdminClientsPage';
import AdminProductsPage from './pages/admin/AdminProductsPage';
import AdminMailPage from './pages/admin/AdminMailPage';
import AdminTagsPage from './pages/admin/AdminTagsPage';
import AdminAgreementsPage from './pages/admin/AdminAgreementsPage';
import './App.css';
import AuthContextProvider from './auth/AuthContext';
import ThemeProvider from './theme/ThemeProvider';

function App() {
    return (
        <ThemeProvider><BrowserRouter>
            <Routes>
                <Route path="/" element={<Navigate to="/login" replace />} />
                <Route path="/logout" element={<LogoutPage />} />
                <Route element={<AuthContextProvider />}>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/consent" element={<ConsentPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/social-email" element={<SocialEmailPage />} />
                {/* Страницы, на которые приводят ссылки из писем. Открываются без входа:
                    пользователь нередко нажимает кнопку в другом браузере. */}
                <Route path="/unsubscribe" element={<UnsubscribePage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/verify-email" element={<VerifyEmailPage />} />
                <Route path="/change-email" element={<ChangeEmailPage />} />
                </Route>
                <Route path="/dashboard" element={<DashboardLayout />}>
                    <Route index element={<Navigate to="/dashboard/profile" replace />} />
                    <Route path="profile" element={<ProfilePage />} />
                    <Route path="security" element={<SecurityPage />} />
                    <Route path="admin/users" element={<AdminUsersPage />} />
                    <Route path="admin/clients" element={<AdminClientsPage />} />
                    <Route path="admin/products" element={<AdminProductsPage />} />
                    <Route path="admin/mail" element={<AdminMailPage />} />
                    <Route path="admin/tags" element={<AdminTagsPage />} />
                    <Route path="admin/agreements" element={<AdminAgreementsPage />} />
                </Route>
            </Routes>
        </BrowserRouter></ThemeProvider>
    );
}

export default App;
